export const GET_COMPANY_ROLES_REQUEST = "GET_COMPANY_ROLES_REQUEST";
export const GET_COMPANY_ROLES_RESPONSE = "GET_COMPANY_ROLES_RESPONSE";

export const CREATE_COMPANY_ROLE_REQUEST = "CREATE_COMPANY_ROLE_REQUEST";
export const CREATE_COMPANY_ROLE_SUCCESS = "CREATE_COMPANY_ROLE_SUCCESS";
export const CREATE_COMPANY_ROLE_FAILURE = "CREATE_COMPANY_ROLE_FAILURE";

export const GET_COMPANY_ROLE_REQUEST = "GET_COMPANY_ROLE_REQUEST";
export const GET_COMPANY_ROLE_RESPONSE = "GET_COMPANY_ROLE_RESPONSE";
export const CLEAR_COMPANY_ROLE = "CLEAR_COMPANY_ROLE";

export const UPDATE_COMPANY_ROLE_REQUEST = "UPDATE_COMPANY_ROLE_REQUEST";
export const UPDATE_COMPANY_ROLE_SUCCESS = "UPDATE_COMPANY_ROLE_SUCCESS";
export const UPDATE_COMPANY_ROLE_FAILURE = "UPDATE_COMPANY_ROLE_FAILURE";

export const DELETE_COMPANY_ROLE_REQUEST = "DELETE_COMPANY_ROLE_REQUEST";
export const DELETE_COMPANY_ROLE_SUCCESS = "DELETE_COMPANY_ROLE_SUCCESS";
export const DELETE_COMPANY_ROLE_FAILURE = "DELETE_COMPANY_ROLE_FAILURE";
